module.exports = __webpack_public_path__ + "static/media/etrack-white.6dbd448d.svg";